import "./DatatableOrders.css";
import { DataGrid } from "@mui/x-data-grid";
import { ordersColumns } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";

const DatatableOrders = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await axios.get("http://localhost:5000/api/orders/orders");

                // Ajouter un ID séquentiel pour l'affichage tout en conservant l'ID Firebase réel
                const ordersWithSequentialIds = response.data.map((order, index) => ({
                    ...order,
                    sequentialId: index + 1, // ID séquentiel pour l'affichage
                }));

                setData(ordersWithSequentialIds);
            } catch (err) {
                console.error("Erreur lors de la récupération des commandes :", err);
                setError("Erreur lors de la récupération des commandes.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, []);

    const handleAcceptOrder = async (orderId) => {
        try {
            const cleanOrderId = orderId.trim();  // Nettoyer l'ID de tout espace ou retour à la ligne
            await axios.put(`http://localhost:5000/api/orders/${cleanOrderId}/accept`);
            // Mettre à jour l'état local après l'acceptation
            setData((prevData) =>
                prevData.map((order) =>
                    order.id === cleanOrderId
                        ? { ...order, status: "accepté" }  // Changer le statut de la commande
                        : order
                )
            );
            alert("Commande acceptée avec succès !");
        } catch (error) {
            console.error("Erreur lors de l'acceptation de la commande:", error);
            alert("Erreur lors de l'acceptation de la commande.");
        }
    };

    const handleRejectOrder = async (orderId) => {
        try {
            await axios.put(`http://localhost:5000/api/orders/${orderId}/reject`);
            // Mettre à jour l'état local après le rejet
            setData((prevData) =>
                prevData.map((order) =>
                    order.id === orderId
                        ? { ...order, status: "refusé" }  // Changer le statut de la commande
                        : order
                )
            );
            alert("Commande refusée avec succès !");
        } catch (error) {
            console.error("Erreur lors du refus de la commande :", error);
            alert("Erreur lors du refus de la commande.");
        }
    };


    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 300,
            renderCell: (params) => {
                const isAccepted = params.row.status === "accepté";
                const isRejected = params.row.status === "refusé";

                return (
                    <div className="cellAction">
                        {/* Icône pour "Voir" */}
                        <Link to={`/admin/products/${params.row.id}`} style={{ textDecoration: "none" }}>
                            <VisibilityIcon
                                className="viewIcon"
                                style={{ color: "#9caf7d", cursor: "pointer", marginRight: "10px" }}
                                titleAccess="Voir"
                            />
                        </Link>

                        {!isAccepted && !isRejected && (
                            <>
                                <button
                                    className="acceptButton"
                                    onClick={() => handleAcceptOrder(params.row.id)}
                                >
                                    Accepter
                                </button>
                                <button
                                    className="rejectButton"
                                    onClick={() => handleRejectOrder(params.row.id)}
                                >
                                    Rejeter
                                </button>
                            </>
                        )}
                        {isAccepted && <span className="statusAccepted">Accepté</span>}
                        {isRejected && <span className="statusRejected">Refusé</span>}
                    </div>
                );
            },
        },
    ];

    if (loading) {
        return <div>Chargement des commandes...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="datatable">
            <DataGrid
                className="datagrid"
                rows={data}
                columns={ordersColumns.concat(actionColumn)}
                pageSize={9}
                rowsPerPageOptions={[9]}
                checkboxSelection
                getRowId={(row) => row.id}
            />
        </div>
    );
};

export default DatatableOrders;
